import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(
          _vm._s(_vm.mode == "view" ? "Ver solicitud" : "Crear solicitud")
        ),
      ]),
      _vm._t("default"),
      _c(
        "actions-component",
        [
          _c(
            "template",
            { slot: "description" },
            [
              _c(VBreadcrumbs, {
                staticClass: "pa-0",
                attrs: { items: _vm.breadcrumbs },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "actions" },
            [
              !(_vm.mode === "view")
                ? _c(
                    VBtn,
                    {
                      staticClass: "ml-1 btn-inca-secondary",
                      attrs: { dense: "", outlined: "" },
                      on: {
                        click: function ($event) {
                          return _vm.addItem_pipe()
                        },
                      },
                    },
                    [
                      _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-plus-circle-outline"),
                      ]),
                      _vm._v("Añadir"),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        VCard,
        { staticClass: "mt-2" },
        [
          _c(
            VCardText,
            [
              _c(
                VForm,
                { ref: "form" },
                [
                  _c(
                    VRow,
                    { staticClass: "px-2 pt-2", attrs: { justify: "center" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v("Proyecto")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "4" } },
                        [
                          _c(VSelect, {
                            key: _vm.key_aux,
                            attrs: {
                              outlined: !(_vm.mode === "view"),
                              readonly: _vm.mode === "view",
                              filled: _vm.mode === "view",
                              dense: "",
                              items: _vm.mlops_projects,
                              "hide-details": "auto",
                              "item-text": "name",
                              "item-value": "id",
                              rules: [
                                function (v) {
                                  return (
                                    !!v || _vm.$t("my_tasks.modals.required")
                                  )
                                },
                              ],
                            },
                            model: {
                              value: _vm.project,
                              callback: function ($$v) {
                                _vm.project = $$v
                              },
                              expression: "project",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v("Configuración")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "4" } },
                        [
                          _c(VSelect, {
                            attrs: {
                              outlined: !(_vm.mode === "view"),
                              readonly: _vm.mode === "view",
                              filled: _vm.mode === "view",
                              dense: "",
                              items: _vm.mlops_configs,
                              "hide-details": "auto",
                              "item-text": "project_id",
                              "item-value": "id",
                              rules: [
                                function (v) {
                                  return (
                                    !!v || _vm.$t("my_tasks.modals.required")
                                  )
                                },
                              ],
                            },
                            model: {
                              value: _vm.config,
                              callback: function ($$v) {
                                _vm.config = $$v
                              },
                              expression: "config",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(VDataTable, {
                    key: _vm.key_table,
                    staticClass: "table-inca",
                    attrs: {
                      headers: _vm.headers_tabla,
                      "hide-default-footer": "",
                      items: _vm.resources,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item.name",
                        fn: function (data) {
                          return [
                            _c(VTextField, {
                              attrs: {
                                rules: [
                                  function (v) {
                                    return (
                                      !!v || _vm.$t("my_tasks.modals.required")
                                    )
                                  },
                                ],
                                required: "",
                                dense: "",
                                "hide-details": "auto",
                                outlined: !(_vm.mode === "view"),
                                readonly: _vm.mode === "view",
                                filled: _vm.mode === "view",
                              },
                              model: {
                                value: data.item.name,
                                callback: function ($$v) {
                                  _vm.$set(data.item, "name", $$v)
                                },
                                expression: "data.item.name",
                              },
                            }),
                          ]
                        },
                      },
                      {
                        key: "item.version",
                        fn: function (data) {
                          return [
                            _c(VTextarea, {
                              attrs: {
                                rules: [
                                  function (v) {
                                    return (
                                      !!v || _vm.$t("my_tasks.modals.required")
                                    )
                                  },
                                ],
                                required: "",
                                dense: "",
                                "hide-details": "auto",
                                rows: "1",
                                outlined: !(_vm.mode === "view"),
                                readonly: _vm.mode === "view",
                                filled: _vm.mode === "view",
                              },
                              model: {
                                value: data.item.version,
                                callback: function ($$v) {
                                  _vm.$set(data.item, "version", $$v)
                                },
                                expression: "data.item.version",
                              },
                            }),
                          ]
                        },
                      },
                      {
                        key: "item.actions",
                        fn: function (ref) {
                          var item = ref.item
                          var index = ref.index
                          return [
                            _c(
                              VBtn,
                              {
                                staticClass: "btn-icon-inca",
                                attrs: { icon: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openDialog(item, index)
                                  },
                                },
                              },
                              [
                                _c(VIcon, { attrs: { small: "" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.mode == "view"
                                        ? "icon-view"
                                        : "mdi-cog"
                                    )
                                  ),
                                ]),
                              ],
                              1
                            ),
                            !(_vm.mode === "view")
                              ? _c(
                                  VBtn,
                                  {
                                    staticClass: "btn-icon-inca",
                                    attrs: { icon: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeItem_pipe(index)
                                      },
                                    },
                                  },
                                  [
                                    _c(VIcon, { attrs: { small: "" } }, [
                                      _vm._v("icon-delete"),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VCardActions,
            [
              _c(VSpacer),
              !(_vm.mode === "view") && !(_vm.resources.length == 0)
                ? _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: { click: _vm.saveRequest },
                    },
                    [
                      _c(
                        VIcon,
                        { staticClass: "mr-1", attrs: { small: "" } },
                        [_vm._v("mdi-check-circle-outline")]
                      ),
                      _vm._v("Solicitar"),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "DialogsComponent",
        {
          ref: _vm.DIALOG_RESOURCES,
          attrs: { title: "Configurar recurso", width: 1000 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c(
                VForm,
                { ref: "formDialog" },
                [
                  _c(
                    VRow,
                    { attrs: { justify: "center" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v("Tipo")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c(VSelect, {
                            attrs: {
                              outlined: !(_vm.mode === "view"),
                              readonly: _vm.mode === "view",
                              filled: _vm.mode === "view",
                              dense: "",
                              items: _vm.type_options,
                              "hide-details": "auto",
                              rules: [
                                function (v) {
                                  return (
                                    !!v || _vm.$t("my_tasks.modals.required")
                                  )
                                },
                              ],
                            },
                            model: {
                              value: _vm.resource_aux.type,
                              callback: function ($$v) {
                                _vm.$set(_vm.resource_aux, "type", $$v)
                              },
                              expression: "resource_aux.type",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { attrs: { justify: "center" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v(_vm._s(_vm.$t("tablas.project")))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              outlined: !(_vm.mode === "view"),
                              readonly: _vm.mode === "view",
                              filled: _vm.mode === "view",
                              dense: "",
                              "hide-details": "auto",
                              rules: [
                                function (v) {
                                  return (
                                    !!v || _vm.$t("my_tasks.modals.required")
                                  )
                                },
                              ],
                            },
                            model: {
                              value: _vm.resource_aux.project,
                              callback: function ($$v) {
                                _vm.$set(_vm.resource_aux, "project", $$v)
                              },
                              expression: "resource_aux.project",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { attrs: { justify: "center" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v(_vm._s(_vm.$t("tablas.dataset")))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              outlined: !(_vm.mode === "view"),
                              readonly: _vm.mode === "view",
                              filled: _vm.mode === "view",
                              dense: "",
                              "hide-details": "auto",
                              rules: [
                                function (v) {
                                  return (
                                    !!v || _vm.$t("my_tasks.modals.required")
                                  )
                                },
                              ],
                            },
                            model: {
                              value: _vm.resource_aux.dataset,
                              callback: function ($$v) {
                                _vm.$set(_vm.resource_aux, "dataset", $$v)
                              },
                              expression: "resource_aux.dataset",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.resource_aux.type == "bigquery.tables"
                    ? _c(
                        VRow,
                        { attrs: { justify: "center" } },
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "3" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [_vm._v(_vm._s(_vm.$t("tablas.table")))]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "9" } },
                            [
                              _c(VTextField, {
                                attrs: {
                                  outlined: !(_vm.mode === "view"),
                                  readonly: _vm.mode === "view",
                                  filled: _vm.mode === "view",
                                  dense: "",
                                  "hide-details": "auto",
                                  rules: [
                                    function (v) {
                                      return (
                                        !!v ||
                                        _vm.$t("my_tasks.modals.required")
                                      )
                                    },
                                  ],
                                },
                                model: {
                                  value: _vm.resource_aux.table,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.resource_aux, "table", $$v)
                                  },
                                  expression: "resource_aux.table",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.resource_aux.type == "bigquery.tables"
                    ? _c(
                        VRow,
                        { staticClass: "mb-2", attrs: { justify: "center" } },
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "3" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [_vm._v("Schema(.json)")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "9" } },
                            [
                              _vm.mode === "view"
                                ? _c(VTextField, {
                                    attrs: {
                                      dense: "",
                                      outlined: !(_vm.mode === "view"),
                                      readonly: _vm.mode === "view",
                                      filled: _vm.mode === "view",
                                      "hide-details": "auto",
                                      "append-icon": "mdi-download ",
                                    },
                                    on: {
                                      "click:append": function ($event) {
                                        return _vm.downloadFile(
                                          _vm.resource_aux.schema_file.route,
                                          _vm.resource_aux.schema_file.name
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.resource_aux.schema_file.name,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.resource_aux.schema_file,
                                          "name",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "resource_aux.schema_file.name",
                                    },
                                  })
                                : _c("DragFileComponent", {
                                    attrs: { type: "pdf" },
                                    on: {
                                      pdf: function ($event) {
                                        return _vm.getschema($event)
                                      },
                                    },
                                  }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    VRow,
                    { staticClass: "mb-2", attrs: { justify: "center" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v("Argumentos")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c(VDataTable, {
                            staticClass: "table-inca",
                            attrs: {
                              headers: _vm.headers_arguments,
                              "hide-default-footer": "",
                              items: _vm.arguments2,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "header.actions",
                                fn: function (ref) {
                                  var header = ref.header
                                  return [
                                    !(_vm.mode === "view")
                                      ? _c(
                                          VBtn,
                                          {
                                            attrs: { icon: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.addItem()
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              VIcon,
                                              { attrs: { small: "" } },
                                              [
                                                _vm._v(
                                                  "mdi-plus-circle-outline"
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "item.name",
                                fn: function (data) {
                                  return [
                                    _c(VTextField, {
                                      attrs: {
                                        rules: [
                                          function (v) {
                                            return (
                                              !!v ||
                                              _vm.$t("my_tasks.modals.required")
                                            )
                                          },
                                        ],
                                        required: "",
                                        dense: "",
                                        "hide-details": "auto",
                                        outlined: !(_vm.mode === "view"),
                                        readonly: _vm.mode === "view",
                                        filled: _vm.mode === "view",
                                      },
                                      model: {
                                        value: data.item.name,
                                        callback: function ($$v) {
                                          _vm.$set(data.item, "name", $$v)
                                        },
                                        expression: "data.item.name",
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "item.description",
                                fn: function (data) {
                                  return [
                                    _c(VTextarea, {
                                      attrs: {
                                        rules: [
                                          function (v) {
                                            return (
                                              !!v ||
                                              _vm.$t("my_tasks.modals.required")
                                            )
                                          },
                                        ],
                                        required: "",
                                        dense: "",
                                        "hide-details": "auto",
                                        rows: "1",
                                        outlined: !(_vm.mode === "view"),
                                        readonly: _vm.mode === "view",
                                        filled: _vm.mode === "view",
                                      },
                                      model: {
                                        value: data.item.description,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            data.item,
                                            "description",
                                            $$v
                                          )
                                        },
                                        expression: "data.item.description",
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "item.actions",
                                fn: function (data) {
                                  return [
                                    !(_vm.mode === "view")
                                      ? _c(
                                          VBtn,
                                          {
                                            staticClass: "btn-icon-inca",
                                            attrs: { icon: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeItem(data)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              VIcon,
                                              { attrs: { small: "" } },
                                              [_vm._v("icon-delete")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { attrs: { justify: "center" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v("Roles")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c(
                            "ul",
                            {
                              staticClass: "pl-4",
                              staticStyle: {
                                border: "1px solid #838383",
                                "border-radius": "18px",
                                "padding-top": "10px",
                              },
                            },
                            _vm._l(_vm.roles, function (rol, index) {
                              return _c(
                                "li",
                                [
                                  _c(
                                    "span",
                                    { style: { "font-weight": "500" } },
                                    [_vm._v(_vm._s(rol))]
                                  ),
                                  !(_vm.mode === "view")
                                    ? _c(
                                        VBtn,
                                        {
                                          staticStyle: {
                                            width: "auto",
                                            height: "auto",
                                          },
                                          attrs: { icon: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.deletefunc(index)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            VIcon,
                                            { attrs: { small: "" } },
                                            [_vm._v("mdi-close")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                          !(_vm.mode === "view")
                            ? _c(
                                VRow,
                                { staticClass: "pt-2" },
                                [
                                  _c(
                                    VCol,
                                    { attrs: { cols: "9" } },
                                    [
                                      _c(VTextarea, {
                                        attrs: {
                                          outlined: "",
                                          dense: "",
                                          "hide-details": "auto",
                                          rows: "1",
                                        },
                                        model: {
                                          value: _vm.rol_aux,
                                          callback: function ($$v) {
                                            _vm.rol_aux = $$v
                                          },
                                          expression: "rol_aux",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    VCol,
                                    { attrs: { cols: "2" } },
                                    [
                                      _c(
                                        VBtn,
                                        {
                                          attrs: { outlined: "", dense: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.addRow(_vm.rol_aux)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            VIcon,
                                            { attrs: { small: "" } },
                                            [_vm._v("icon-add")]
                                          ),
                                          _vm._v(_vm._s(_vm.$t("common.add"))),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              !(_vm.mode === "view")
                ? _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: { click: _vm.saveConfig },
                    },
                    [
                      _c(
                        VIcon,
                        { staticClass: "mr-1", attrs: { small: "" } },
                        [_vm._v("mdi-check-circle-outline")]
                      ),
                      _vm._v(_vm._s(_vm.$t("botones.boton_aceptar"))),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }